<template>
  <div>
    <div class="content-header row">
      <div class="content-header-left col-12 mb-2 mt-1">
        <div class="row breadcrumbs-top">
          <div class="col-12">
            <div class="card">
              <Alert :text="$t('enterprise_profile_phone_number_validation')" type="danger" dismissable="false"
                     v-if="!isDisable && enterprisePhoneErrorColor" />
              <Alert :text="$t('enterprise_profile_street_one_name_validation')" type="danger" dismissable="false"
                     v-if="streetNameOneError" />
              <Alert :text="$t('enterprise_profile_street_two_name_validation')" type="danger" dismissable="false"
                     v-if="streetNameTwoError" />
              <Alert :text="$t('enterprise_profile_city_name_validation')" type="danger" dismissable="false"
                     v-if="enterpriseCityOneError" />
              <Alert :text="$t('enterprise_profile_state_name_validation')" type="danger" dismissable="false"
                     v-if="enterpriseStateOneError"/>
              <Alert :text="$t('enterprise_profile_country_name_validation')" type="danger" dismissable="false"
                     v-if="enterpriseCountryOneError" />
              <Alert :text="$t('enterprise_profile_street_one_name_validation')" type="danger" dismissable="false"
                     v-if="streetNameOneOptionalError"/>
              <Alert :text="$t('enterprise_profile_street_two_name_validation')" type="danger" dismissable="false"
                     v-if="streetNameTwoOptionalError" />
              <Alert :text="$t('enterprise_profile_city_name_validation')" type="danger" dismissable="false"
                     v-if="enterpriseCityOneOptionalError" />
              <Alert :text="$t('enterprise_profile_state_name_validation')" type="danger" dismissable="false"
                     v-if="enterpriseStateOneOptionalError" />
              <Alert :text="$t('enterprise_profile_country_name_validation')" type="danger" dismissable="false"
                     v-if="enterpriseCountryOneOptionalError" />
              <Alert :text="$t('enterprise_profile_website_validation')" type="danger" dismissable="false"
                     v-if="websiteError" />
              <Alert :text="$t('enterprise_profile_website_validation')" type="danger" dismissable="false"
                     v-if="emailError" />
              <Alert :text="$t('enterprise_profile_code_validation')" type="danger" dismissable="false"
                     v-if="postalCodeError" />
              <Alert :text="$t('enterprise_profile_code_validation')" type="danger" dismissable="false"
                     v-if="postalCodeBillingError" />
              <div class="card-header headerDiv">
                <Alert :text="apiErrorText" type="danger" dismissable="false" v-if="apiErrorText !=''" />
                <h5 class="contactHeading"> {{ $t('organisation_profile_module_business_address_heading') }} </h5>
              </div>
              <div class="card-content">
                <form action="">
                  <div class="beforeRowDiv">
                    <div class="form-group row">
                      <div class="col-md-6 col-sm-12">
                        <label for="org-name" class="postalCodeBillingLabel">{{
    $t('organisation_profile_module_street_name_1_label')
}}</label>
                        <input type="text" class="form-control streetInput" v-model="streetNameOne"
                               :class="streetNameOneError ? 'errClass':''" :disabled="isDisable" />

                      </div>
                      <div class="col-md-6 col-sm-12">
                        <label for="org-id" class="postalCodeBillingLabel">{{
    $t('organisation_profile_module_street_name_2_label')
}}</label>
                        <input type="text" class="form-control streetInput" v-model="streetNameTwo"
                               :class="streetNameTwoError ? 'errClass':''"  :disabled="isDisable"/>

                      </div>
                    </div>
                    <div class="form-group row beforeCityDiv">
                      <div class="col-md-6 col-sm-6">
                        <div class="form-group row">
                          <div class="col-md-6 col-sm-12">
                            <label for="org-name" class="postalCodeBillingLabel">{{
    $t('organisation_profile_module_city_label')
}}</label>
                            <input type="text" class="form-control postalCodeBilling" v-model="city"
                                   :disabled="isDisable" :class="enterpriseCityOneError ? 'errClass':''" />
                          </div>
                          <div class="col-md-6 col-sm-12">
                            <label for="org-name" class="postalCodeBillingLabelState">{{
    $t('organisation_profile_module_state_province_label')
}}</label>
                            <input type="text" class="form-control postalCodeBillingState" v-model="state" :disabled="isDisable"
                                                :class="enterpriseStateOneError ? 'errClass':''" />
                          </div>
                        </div>

                      </div>
                      <div class="col-md-6 col-sm-6">
                        <div class="form-group row">
                          <div class="col-md-6 col-sm-12">
                            <label for="org-name" class="postalCodeBillingLabel">{{
    $t('organisation_profile_module_postal_code_label')
}}</label>
                            <input type="text" class="form-control postalCodeBilling" v-model="postalCode"
                                    @keypress="validateNumber" :class="postalCodeError ? 'errClass':''"
                                   :disabled="isDisable" />
                          </div>
                          <div class="col-md-6 col-sm-12">
                            <label for="org-name" class="postalCodeBillingLabel ">{{
    $t('organisation_profile_module_country_label')
}}</label>
                            <select  class='form-control postalCodeBillingState' v-model="country" :disabled="isDisable"
                                     :class="enterpriseCountryOneError ? 'errClass':''" >
                              <option value="default" disabled selected>{{ $t('clo_user_add_user_popup_country_dropdown_default') }}
                              </option>
                              <option v-for="(country, index) in totalCountries" :value="country" :key="index">{{
                                  countryName(country)
                                }}
                              </option>
                            </select>
                          </div>
                        </div>
                      </div>

                    </div>
                  </div>
                  <div class="headingDiv">

                    <h5 class="headingStyle tickMargin"> <img :src="tickIcon" class="titleFont" alt="Tick image">
                      {{ $t('organisation_profile_module_billing_address_heading') }}
                    </h5>
                  </div>
                  <div class="divBorder">
                    <div class="form-group row streetRow">
                      <div class="col-md-6 col-sm-12">
                        <label for="org-name " class="postalCodeBillingLabel">{{
    $t('organisation_profile_module_street_name_1_label')
}}</label>
                        <input type="text" class="form-control streetInput" v-model="streetBillingNameOne"
                               :disabled="isDisable"  :class="streetNameOneOptionalError ? 'errClass':''"/>

                      </div>
                      <div class="col-md-6 col-sm-12">
                        <label for="org-id " class="postalCodeBillingLabel">{{
    $t('organisation_profile_module_street_name_2_label')
}}</label>
                        <input type="text" class="form-control streetInput" v-model="streetBillingNameTwo"
                               :disabled="isDisable"  :class="streetNameTwoOptionalError ? 'errClass':''" />

                      </div>
                    </div>
                    <div class="form-group row beforeCityDiv">
                      <div class="col-md-6 col-sm-6">
                        <div class="form-group row">
                          <div class="col-md-6 col-sm-12">
                            <label for="org-name" class="postalCodeBillingLabel">{{
    $t('organisation_profile_module_city_label')
}}</label>
                            <input type="text" class="form-control postalCodeBilling" v-model="cityBilling"
                                    :class="enterpriseCityOneOptionalError ? 'errClass':''"  :disabled="isDisable" />
                          </div>
                          <div class="col-md-6 col-sm-12">
                            <label for="org-name" class="postalCodeBillingLabelState">{{
    $t('organisation_profile_module_state_province_label')
}}</label>
                            <input type="text" class="form-control postalCodeBillingState" v-model="stateBilling"
                                   :disabled="isDisable" :class="enterpriseStateOneOptionalError ? 'errClass':''"  />
                          </div>
                        </div>

                      </div>
                      <div class="col-md-6 col-sm-6">
                        <div class="form-group row">
                          <div class="col-md-6 col-sm-12">
                            <label for="org-name" class="postalCodeBillingLabel">{{
    $t('organisation_profile_module_postal_code_label')
}}</label>
                            <input type="text" class="form-control postalCodeBilling" v-model="postalCodeBilling"
                                   @keypress="validateNumber" :class="postalCodeBillingError ? 'errClass':''"
                                   :disabled="isDisable" />
                          </div>
                          <div class="col-md-6 col-sm-12">
                            <label for="org-name" class="postalCodeBillingLabel ">{{
    $t('organisation_profile_module_country_label')
}}</label>
                            <select  class='form-control postalCodeBillingState' v-model="countryBilling" :disabled="isDisable"
                                     :class="enterpriseCountryOneOptionalError ? 'errClass':''" >
                              <option value="default" disabled selected>{{ $t('clo_user_add_user_popup_country_dropdown_default') }}
                              </option>
                              <option v-for="(country, index) in totalCountries" :value="country" :key="index">{{
                                  countryName(country)
                                }}
                              </option>
                            </select>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="contactHeadingDiv">
                    <h5 class="contactHeading"> {{ $t('organisation_profile_module_contact_information_heading') }}
                    </h5>
                  </div>
                  <div class="beforeRowDiv">
                    <div class="form-group row rowStyle">
                      <div class="col-md-6 col-sm-12">
                        <label for="org-name " class="labelStyle">
                          {{ $t('organisation_profile_module_general_email_label') }}</label>
                        <input type="text" class="form-control mailInput" v-model="generalEmail"
                               :class="emailError ? 'errClass':''" :disabled="isDisable"
                                             />

                      </div>
                      <div class="col-md-6 col-sm-12">
                        <label for="org-id" class="labelStyle">{{ $t('organisation_profile_module_phone_number_label')
}}</label>
                        <PhoneNumberInput :phoneNumber="phoneNumber" :onCountryCodeSelect="onCountryCodeSelect"
                          :onPhoneNumberChange="onPhoneNumberChange" :disabled="isDisable" :validate="enterprisePhoneValidate"
                                          class=""
                                          :class="!isDisable && enterprisePhoneErrorColor ? 'form-control phoneNumberInput errClass ':'form-control phoneNumberInput'"
                                           />
                      </div>
                    </div>

                    <div class="form-group row websiteRowDiv">
                      <div class="col-md-6 col-sm-12">
                        <label for="org-name " class="labelStyle">
                          {{ $t('organisation_profile_module_website_label') }}</label>
                        <input type="text" class="form-control websiteInput" v-model="website"
                               :disabled="isDisable" :class="websiteError ? 'errClass':''" />

                      </div>
                    </div>
                  </div>
                </form>
              </div>
              <div class="modal-footer" v-if="!isDisable">
                <button type="button" class="btn btn-light-secondary" @click="cancelData">
                  <em class="bx bx-x d-block d-sm-none"></em>
                  <span class="d-none d-sm-block " style="color: white" >{{
                      $t('organisation_profile_cancel_button')
                    }}</span>
                </button>
                <button type="button" class="btn btn-primary ml-1" @click="saveData">
                  <em class="bx bx-check d-block d-sm-none"></em>
                  <span class="d-none d-sm-block" >{{ $t('organisation_profile_save_button')
                    }}</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Alert from "@/components/Alerts";
import PhoneNumberInput from "@/components/PhoneNumberInput/PhoneNumberInput";
import { getCountryName } from "@/app-assets/js/get-countries.js";
export default {
  name: "OrganizationProfilePage",
  props: ['editable'],
  data() {
    return {
      streetNameOne: "",
      streetNameTwo: "",
      city: "",
      state: "",
      postalCode: "",
      country: "default",
      streetBillingNameOne: "",
      streetBillingNameTwo: "",
      cityBilling: "",
      stateBilling: "",
      postalCodeBilling: "",
      countryBilling: "default",
      generalEmail: "",
      phoneNumber: "",
      website: "",
      organization: [],
      apiErrorText: "",
      tickIcon: require('@/assets/tick-mark.png').default,
      orgId: this.$route.params.org,
      isDisable: false,
      editable:'',
      enterprisePhoneError:false,
      enterprisePhoneErrorColor:false,
      streetNameOneError:false,
      streetNameTwoError:false,
      enterpriseCityOneError:false,
      enterpriseStateOneError:false,
      enterpriseCountryOneError:false,
      streetNameOneOptionalError:false,
      streetNameTwoOptionalError:false,
      enterpriseCityOneOptionalError:false,
      enterpriseStateOneOptionalError:false,
      enterpriseCountryOneOptionalError:false,
      websiteError:false,
      postalCodeError:false,
      postalCodeBillingError:false,
      emailError:false,
      totalCountries:[],
    }
  },
  components: {
    Alert,
    PhoneNumberInput
  },
  methods: {
    onCountryCodeSelect({ name, iso2, dialCode }) {
      this.dialCode = dialCode;
    },
    onPhoneNumberChange(value) {
      this.phoneNumber = value;
    },
    countryName(element) {
      if (element) {
        return getCountryName(element.toUpperCase());
      }
    },
    getOrganisation() {
      let self = this;
      console.log("route-param", this.$route.params.edit)
      self.editable = this.$route.params.edit
      if(self.editable !='edit'){
        self.isDisable = true;
      } else {
        self.isDisable = false;
      }
      this.$apiCall.get(`v1/clo-organization/${self.orgId}`).then((response) => {
        self.organization = response.data;
        self.generalEmail = self.organization.email;
        self.cityBilling = self.organization.billingAddress.city
        self.stateBilling = self.organization.billingAddress.state
        self.postalCodeBilling = self.organization.billingAddress.zip
        self.countryBilling = self.organization.billingAddress.currentCountry
        self.streetBillingNameOne = self.organization.billingAddress.street
        self.streetBillingNameTwo = self.organization.billingAddress.floor
        self.streetNameTwo = self.organization.officeAddress.floor
        self.city = self.organization.officeAddress.city
        self.state = self.organization.officeAddress.state
        self.postalCode = self.organization.officeAddress.zip
        self.country = self.organization.officeAddress.currentCountry
        self.streetNameOne = self.organization.officeAddress.street
        self.website = self.organization.website
        self.phoneNumber = self.organization.phoneNumber;
      })
        .catch((error) => {
          self.apiErrorText =
            `<strong>Ops!</strong> ${error.response.data.message}`;

        });
    },
    getCountries(){
      let self = this;
      self.totalCountries = ['lb','jo','pl','ua','us','ca','pe','co' ]
    },
    isRequiredEnterpriseBusinessValidation(){
      let self = this;
      if(self.streetNameOne !=''){
        self.requiredError = false;
        self.streetNameOneError = false;
      } else {
        self.requiredError = true;
        self.streetNameOneError = true;
      }
      if(self.streetNameTwo !=''){
        self.streetNameTwoError = false;
      } else {
        self.streetNameTwoError = true;
      }
      if(self.city !=''){
        self.requiredError = false;
        self.enterpriseCityOneError = false;
      } else {
        self.requiredError = true;
        self.enterpriseCityOneError = true;
      }
      if(self.state !=''){
        self.requiredError = false;
        self.enterpriseStateOneError = false;
      } else {
        self.requiredError = true;
        self.enterpriseStateOneError = true;
      }
      if(self.country  !='default'){
        self.requiredError = false;
        self.enterpriseCountryOneError = false;
      } else {
        self.requiredError = true;
        self.enterpriseCountryOneError = true;
      }
      if(self.postalCode !=''){
        self.postalCodeError = false;
      } else {
        self.postalCodeError = true;
      }
    },
    isRequiredEnterpriseBillingValidation(){
      let self = this;
      if(self.streetBillingNameOne !=''){
        self.requiredError = false;
        self.streetNameOneOptionalError = false;
      } else {
        self.requiredError = true;
        self.streetNameOneOptionalError = true;
      }
      if(self.postalCodeBilling !=''){
        self.postalCodeBillingError = false;
      } else {
        self.postalCodeBillingError = true;
      }
      if(self.streetBillingNameTwo !=''){
        self.requiredError = false;
        self.streetNameTwoOptionalError = false;
      } else {
        self.requiredError = true;
        self.streetNameTwoOptionalError = true;
      }
      if(self.cityBilling !=''){
        self.requiredError = false;
        self.enterpriseCityOneOptionalError = false;
      } else {
        self.requiredError = true;
        self.enterpriseCityOneOptionalError = true;
      }
      if(self.stateBilling !=''){
        self.requiredError = false;
        self.enterpriseStateOneOptionalError = false;
      } else {
        self.requiredError = true;
        self.enterpriseStateOneOptionalError = true;
      }
      if(self.countryBilling !='default'){
        self.requiredError = false;
        self.enterpriseCountryOneOptionalError = false;
      } else {
        self.requiredError = true;
        self.enterpriseCountryOneOptionalError = true;
      }

    },
    isRequiredEnterpriseContactInformation(){
      let self = this;
      if(self.website !=''){
        self.requiredError = false;
        self.websiteError = false;
      } else {
        self.requiredError = true;
        self.websiteError = true;
      }
       if(self.generalEmail !=''){
        self.emailError = false;
        self.validateEmail()
      } else {
        self.emailError = true;
      }
    },
    enterprisePhoneValidate(telnumber) {
      console.log("enterprisePhoneValidate ", telnumber)
      let self = this
      if(telnumber.valid) {
        self.enterprisePhoneErrorColor = false;
      } else {
        self.enterprisePhoneErrorColor = true;
      }
    },
    saveData(){
      let self = this;
      this.isRequiredEnterpriseBusinessValidation();
      this.isRequiredEnterpriseBillingValidation();
      this.isRequiredEnterpriseContactInformation();
      self.data={
        "officeAddress": {
          "street1": self.streetNameOne,
          "currentCountry": self.country,
          "street2": self.streetNameTwo,
          "zip": self.postalCode,
          "state": self.state,
          "city": self.city
        },
        "billingAddress": {
          "state": self.stateBilling,
          "currentCountry": self.countryBilling,
          "street1": self.streetBillingNameOne,
          "zip": self.postalCodeBilling,
          "street2": self.streetBillingNameTwo,
          "city": self.cityBilling
        },
        "email": self.generalEmail,
        "phoneNumber":self.phoneNumber,
        "website":self.website,
      };
      if( !self.enterprisePhoneError && !self.streetNameOneError && !self.streetNameTwoError && !self.enterpriseCityOneError && !self.enterpriseStateOneError && !self.emailError
        && !self.enterpriseCountryOneError && !self.streetNameOneOptionalError && !self.streetNameTwoOptionalError && !self.enterpriseCityOneOptionalError && !self.enterpriseStateOneOptionalError
        && !self.enterpriseCountryOneOptionalError && !self.websiteError ) {
        this.$apiCall.patch(`v1/clo-organization/${self.orgId}`, self.data).then((response) => {
          console.log("patch response", response);
          if(response.data){
            self.isDisable = true;
          }
        })
          .catch((error) => {
            self.apiError = true;
            self.apiErrorText = `<strong>Ops!</strong> ${error.response.data.message}`;
          })
      }
    },
    validateEmail(){
      let self = this;
      if(/^[^@]+@\w+(\.\w+)+\w$/.test(self.generalEmail)){
        self.emailError = false;
      } else {
        self.emailError = true;
      }
    },
    cancelData(){
      let self = this;
      self.isDisable = true;
      this.$router.push({ name: 'CLOListPage' })
    },
    validateNumber: (event) => {
      let keyCode = event.keyCode;
      if (keyCode < 48 || keyCode > 57) {
        event.preventDefault();
      }
    },

    // getOrgDetails() {
    //   console.log("orggggggg--------profileeee")
    //   let self = this;
    //   this.$apiCall.get("v1/me").then((response) => {
    //     self.orgId = response.data.cloAccountId
    //     this.getOrganisation()
    //   }).catch((error) => {
    //     self.apiErrorText =
    //       `<strong>Ops!</strong> ${error.response.data.message}`;
    //
    //   });
    // },
  },
  mounted() {
    this.getCountries()
    this.getOrganisation()
  }
}

</script>

<style scoped>
.labelStyle {
  color: rgba(74, 73, 73, 0.7);
  margin-left: 2em;
}

.countryLabelStyle {
  color: rgba(74, 73, 73, 0.7);
}

.websiteInput {
  height: 85%;
  width: 94%;
  margin-left: 2em;
}

.mailInput {
  height: 75%;
  width: 94%;
  margin-left: 2em;
}

.websiteRowDiv {
  margin-top: 2em;
  margin-bottom: 7.5em;
}

.rowStyle {
  margin-top: 2em;
}

.tickMargin {
  margin-left: 2em;
}

.countryCode {
  transform: translate(31px, -44px);
  border: 0px;
}

.phoneNumberInput {
  height: 68%;
  width: 94%;
  margin-left: 2em;
  background-color: #F2F4F4;
}

.input {
  height: 58%;
  width: 94%;
  margin-left: 2em;
}

.beforeRowDiv {
  border-bottom: 1px solid #DFE3E7
}

.contactHeading {
  font-weight: 500;
  font-size: 16px;
  color: #475F7B;

}

.contactHeadingDiv {
  margin-top: 2em;
  margin-left: 2em;
}

.countryBillingInput {
  height: 75%;
  width: 100%;
}

.countryLabel {
  color: rgba(74, 73, 73, 0.7);
}

.postalCodeBilling {
  height: 75%;
  width: 87%;
  margin-left: 2em;
}

.postalCodeBillingState {
  height: 75%;
  width: 87%;
  margin-left: 2em;
}

.postalCodeBillingLabel {
  color: rgba(74, 73, 73, 0.7);
  margin-left: 2em;
}
.postalCodeBillingLabelState {
  color: rgba(74, 73, 73, 0.7);
  margin-left: 2em;
}

.countryBillDiv {
  margin-left: 18em;
}

.postalCodeBillingDiv {
  margin-left: 3.5em;
}

.stateBillingDiv {
  margin-left: 4em;
}

.cityBillingDiv {
  margin-right: 12em;
}

.beforecityBillingDiv {
  margin-top: 2em;
  margin-bottom: 2em
}

.streetInput {
  height: 75%;
  width: 94%;
  margin-left: 2em;
}

.streetRow {
  margin-top: 2em
}

.divBorder {
  border-bottom: 1px solid rgba(189, 190, 190, 0.5)
}

.headingStyle {
  font-weight: 500;
  font-size: 16px;
}

.headingDiv {
  margin-top: 2em;
}

.countryDiv {
  margin-left: 9em;
}

.beforeCityDiv {
  margin-top: 2em;
  margin-bottom: 2em
}

.countryBillingDiv {
  margin-left: 18em;
}

.headerDiv {
  border-top: 1px solid rgba(189, 190, 190, 0.5)
}

.postalCodeBillingCountry {
  height: 75%;
  width: 95%;
}

.postalCodeBillDiv {
  margin-left: 3.5em;
}

@media (max-width: 1366px) {
  .countryBillDiv {
    margin-left: 9.5em;
  }
  .postalCodeBillingState {
  height: 75%;
  width: 87%;
  margin-left: 0em;
}
.postalCodeBillingLabelState {
  color: rgba(74, 73, 73, 0.7);
  margin-left: 0em;
}

  .streetInput {
    height: 75%;
    width: 88%;
    margin-left: 2em;
  }

  .phoneNumberInput {
    height: 68%;
    width: 88%;
    margin-left: 2em;
    background-color: #F2F4F4;
  }

  .websiteInput {
    height: 90%;
    width: 94%;
    margin-left: 2em;
  }

  .postalCodeBilling {
    height: 75%;
    width: 90%;
    margin-left: 2em;
  }

  .postalCodeBillingDiv {
    margin-left: 11.5em;
    margin-right: -3em;
  }

  .countryBillingDiv {
    margin-left: 12.5em;
  }

  .stateBillingDiv {
    margin-left: -.5em;
    margin-right: -9em;
  }

  .cityBillingDiv {
    margin-right: 9em;
  }

  .postalCodeBillingCountry {
    height: 75%;
    width: 100%;
  }

  .postalCodeBillDiv {
    margin-left: 11.5em;
  }
  .errClass {
    border: 1px solid red;
  }

}
</style>

